module.exports = __webpack_public_path__ + "img/weddings_12_V.cacb07fb.jpg";